import { render, staticRenderFns } from "./ImageColumn.vue?vue&type=template&id=af73ac86&scoped=true"
import script from "./ImageColumn.vue?vue&type=script&lang=js"
export * from "./ImageColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af73ac86",
  null
  
)

export default component.exports